<div *ngIf="!loading" class="container mt-3">
    <div class="row mb-3">
        <div class="col-6 col-md-4">
            <h4>Listado de prácticas</h4>
        </div>
        <div class="col-6 col-md-4 text-md-end">
            <button type="button" class="btn btn-danger" (click)="deleteAllPracticeInscriptions()" *ngIf="authService.rol == 1">
                Eliminar todas las inscripciones
            </button>
        </div>
        <div class="col-6 col-md-4 text-md-end">
            <button type="button" class="btn btn-success me-2" (click)="exportToExcel()" *ngIf="authService.rol == 1">
                Exportar a Excel
            </button>
            <!--<button type="button" class="btn btn-primary" (click)="exportToPDF()">Exportar a PDF</button>-->
        </div>
        <div class="col-6 col-md-4 text-md-end" *ngIf="(listPractices.length == 0 && authService.rol == 2)&&authService.status==1">
            <button  type="button" class="btn btn-primary" routerLink="/addpracticeinscription" >
                Inscribir a práctica
            </button>
        </div>
        
    </div>
    
    <div *ngIf="authService.rol==1" class="search-bar mb-3">
        <input type="text" placeholder="Buscar por nombre, apellido, carrera, centro, area, turno o gestión" (input)="onSearch($event)" class="form-control">
    </div>
    

    <div class="table-responsive" *ngIf="filteredPractices.length > 0">
        <table class="table table-hover">
            <thead>
                <tr>
                  <th scope="col" *ngIf="authService.rol==1">Acción</th>
                  <th scope="col">Gestión</th>
                  <th scope="col">Nombres</th>
                  <th scope="col">Apellidos</th>
                  <th scope="col">Carrera</th>
                  <th scope="col">Centro</th>
                  <th scope="col">Area</th>
                  <th scope="col">Turno</th>
                  <th scope="col">Vacantes</th>
                  <th scope="col">Inscritos</th>
                  <th scope="col">Estado</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of filteredPractices" class="table-active">
                  <td *ngIf="authService.rol==1">
                    <button *ngIf="authService.rol==1" (click)="deletePractice(item.id!)" type="button" class="btn btn-secondary btn-sm">Delete</button>
                </td>  
                  <td>{{ item.namemanagement }}</td>
                    <td>{{ item.namestudent }}</td>
                    <td>{{ item.lastname }}</td>
                    <td>{{ item.namecareer }}</td>
                    <td>{{ item.namecenter }}</td>
                    <td>{{ item.namearea }}</td>
                    <td>{{ item.nameturn }}</td>
                    <td>{{ item.quota }}</td>
                    <td>{{ item.enrolled }}</td>
                    <td>{{ item.state === 1 ? 'Habilitado' : 'Deshabilitado' }}</td>
                    
                </tr>
            </tbody>
        </table>
    </div>
    <h5 *ngIf="filteredPractices.length == 0 && authService.status==1">Registra una nueva práctica presionando el botón "Inscribir a práctica"</h5>
    <h5 *ngIf="authService.status==0">NO SE ENCUENTRA EL USUARIO HABILITADO PARA TOMAR PRÁCTICAS. CONTECTESE CON SECRETARIA.</h5>
</div>
